import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';

export default class EventService extends Component {
  static createEvent = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/create_event?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static updateEvent = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/update_event?lang=' + localStorage.getItem('localLang');
      config.method = "post";
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getEventListByCountry = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_country_single_event?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAllEvents = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_all_events?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getEventById = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_event_id?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);

      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static updateStatus = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/approve_event?lang=' + localStorage.getItem('localLang');
      config.method = "post";
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAllEventByCountry = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/event_cat_stats?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

}
